import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { ArrowLeft } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function InsightDetail() {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    axios.get(`${API}/articles/${slug}`)
      .then(({ data }) => setArticle(data))
      .catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) {
    return (
      <div data-testid="insight-notfound" className="bg-[#0B0F0E] py-32 text-center">
        <h1 className="font-display text-5xl text-[#F4EFE6]">Article not found.</h1>
        <Link to="/insights" className="usl-btn-outline mt-8 inline-flex">All insights</Link>
      </div>
    );
  }

  if (!article) return <div className="bg-[#0B0F0E] py-32 text-center text-[#9BA39B]">Loading...</div>;

  return (
    <article data-testid="insight-detail" className="bg-[#0B0F0E]">
      <div className="max-w-3xl mx-auto px-6 md:px-12 pt-20 md:pt-28 pb-16">
        <Link to="/insights" data-testid="insight-back" className="inline-flex items-center gap-2 text-xs tracking-[0.2em] uppercase text-[#C9A24B] hover:text-[#F4EFE6] font-semibold">
          <ArrowLeft size={14} /> All Insights
        </Link>
        {article.tag && <div className="overline mt-10">{article.tag}</div>}
        <h1 data-testid="insight-title" className="font-display text-[#F4EFE6] text-5xl md:text-6xl lg:text-7xl mt-5 leading-[0.95]">{article.title}</h1>
        <div className="text-sm text-[#9BA39B] mt-6">
          {new Date(article.created_at).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" })}
        </div>
      </div>

      {article.cover_image && (
        <div className="max-w-5xl mx-auto px-6 md:px-12 pb-10">
          <img src={article.cover_image} alt={article.title} className="w-full h-[440px] object-cover" />
        </div>
      )}

      <div className="max-w-3xl mx-auto px-6 md:px-12 pb-28">
        <div data-testid="insight-body" className="prose-usl">
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{article.body}</ReactMarkdown>
        </div>
      </div>
    </article>
  );
}
